import {ref} from 'vue'

const devModeOverride = ref(false)
const overrideEnabled = ref(false)

const getViteVar = (key: string) => {
    return import.meta.env[`VITE_${key}`]
}

const getDemoProjectId = () => {
    return import.meta.env.VITE_DEMO_PROJECT_ID
}

const isDevMode = (): boolean => {
    if (devModeOverride.value) {
        return overrideEnabled.value
    }
    return import.meta.env.DEV
}

// @ts-ignore
window.forceDevMode = (enabled: boolean) => {
    devModeOverride.value = true
    overrideEnabled.value = enabled
}

enum Environment {
    Local = 'local',
    PreProduction = 'preproduction',
    Production = 'production',
    Staging = 'staging',
    Unknown = 'unknown'
}

const getEnvironment = () => {
    const {host} = window.location

    if (host.includes('tritt.test')) {
        return Environment.Local
    } else if (host.includes('conta.foo')) {
        return Environment.PreProduction
    } else if (host.includes('conta.no')) {
        return Environment.Production
    } else if (host.includes('tritt.dev')) {
        return Environment.Staging
    } else if (host.includes('conta.dev')) {
        return Environment.Staging
    } else {
        console.error('Unknown environment: ', host)
        return Environment.Unknown
    }
}

const isLocal = () => {
    return getEnvironment() === Environment.Local
}

const isStaging = () => {
    return getEnvironment() === Environment.Staging
}

const isPreProduction = () => {
    return getEnvironment() === Environment.PreProduction
}

const isProduction = () => {
    return getEnvironment() === Environment.Production
}

const getEnvPrefix = (): string => {
    if(isDevMode()) return '[DEV] - '
    if(isStaging()) return '[STAGE] - '
    return ''
}

export {
    getViteVar,
    getDemoProjectId,
    isDevMode,
    isLocal,
    isStaging,
    isPreProduction,
    isProduction,
    Environment,
    getEnvironment,
    getEnvPrefix
}